<template>
  <div class="container">
    <div class="header-container">
      <h1>图片转Webp</h1>
      <p>纯前端canvas压缩为有损压缩</p>
    </div>
    <div class="areas-container">
      <div class="image-area picture-are">
        <div class="image-preview">
          <!-- 图片上传区域，上传后隐藏 -->
          <el-upload
            v-if="!imageUrl"
            class="upload-demo hover-upload"
            ref="upload"
            action="//jsonplaceholder.typicode.com/posts/"
            :auto-upload="false"
            :show-file-list="false"
            :on-change="handleFileChange"
            :on-remove="handleRemove"
            list-type="picture-card"
          >
            <i class="el-icon-plus"></i>
            <p>上传原图</p>
          </el-upload>
          <!-- 图片显示区域 -->
          <div v-if="imageUrl" class="image-container">
            <img :src="imageUrl" alt="Preview" />
            <!-- 鼠标悬停时显示的上传区域 -->
            <div
              class="upload-overlay"
              @mouseover="hover = true"
              @mouseleave="hover = false"
            >
              <el-upload
                class="upload-demo hover-upload"
                ref="hoverUpload"
                action="//jsonplaceholder.typicode.com/posts/"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="handleFileChange"
                :on-remove="handleRemove"
                list-type="picture-card"
              >
                <i class="el-icon-plus"></i>
                <p>点击重新上传</p>
              </el-upload>
            </div>
          </div>
        </div>
      </div>

      <div class="action-area">
        <el-input
          v-if="webpUrl"
          placeholder="请输入WebP文件名"
          v-model="webpFileName"
          :disabled="loading"
        ></el-input>
        <el-button
          type="primary"
          @click="convertToWebp"
          :loading="loading"
          :disabled="!selectedFile"
          >转换</el-button
        >
        <el-button
          v-if="webpUrl"
          type="success"
          @click="downloadWebp"
          :disabled="!webpUrl"
          >下载</el-button
        >
      </div>

      <div class="image-area webp-area">
        <div class="image-preview">
          <img v-if="webpUrl" :src="webpUrl" alt="WebP Preview" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PicToWebp",
  metaInfo: {
    title: "图片转webp", // 设置页面标题
    meta: [
      { name: "description", content: "图片转webp格式，支持上传下载" } // 设置页面描述
    ]
  },
  data() {
    return {
      selectedFile: null,
      imageUrl: "",
      webpUrl: "",
      webpFileName: "",
      loading: false,
      hover: false
    };
  },
  methods: {
    handleFileChange(file, fileList) {
      this.selectedFile = file.raw;
      this.imageUrl = URL.createObjectURL(this.selectedFile);
    },
    handleRemove(file, fileList) {
      this.selectedFile = null;
      this.imageUrl = "";
    },
    convertToWebp() {
      if (!this.selectedFile) return;

      this.loading = true;
      const reader = new FileReader();
      reader.readAsDataURL(this.selectedFile);
      reader.onload = e => {
        const img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          const canvas = document.createElement("canvas");
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          canvas.toBlob(blob => {
            this.webpUrl = URL.createObjectURL(blob);
            this.loading = false;
          }, "image/webp");
        };
      };
    },
    downloadWebp() {
      const link = document.createElement("a");
      link.href = this.webpUrl;
      // 使用webpFileName作为文件名，如果未输入则默认为'image.webp'
      link.download = this.webpFileName.trim()
        ? `${this.webpFileName}.webp`
        : "image.webp";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh; /* 使用视口高度确保占满整个屏幕高度 */
}

.header-container {
  width: 100%; /* 确保header-container占据整个屏幕宽度 */
  text-align: center; /* 使得main_header中的内容水平居中 */
}

.areas-container {
  display: flex;
  justify-content: center; /* 保持原有的水平布局 */
  width: 100%; /* 确保areas-container占据整个屏幕宽度，便于水平布局 */
}

.image-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; /* 水平居中 */
}

.upload-demo {
  cursor: pointer;
  /* ... other styles */
}

.upload-demo i {
  font-size: 32px;
}

.image-container {
  position: relative;
}

.image-preview {
  border: 1px dashed #d9d9d9;
  padding: 5px;
  margin-top: 10px;
  width: 500px;
  height: 500px;
  display: flex;
  flex-direction: column; /* 修改布局方向为垂直 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  position: relative;
}

.image-preview p {
  font-size: 20px;
}

.image-preview img {
  max-width: 100%;
  max-height: 360px;
}

.el-upload {
  border: none;
}

.action-area {
  display: flex;
  flex-direction: column;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  min-height: 150px; /* Adjust this based on your actual layout */
  gap: 20px;
  margin: 0 20px;
}

.upload-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7); /* Semi-transparent overlay */
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 999;
}

.hover-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.hover-upload:hover {
  opacity: 1; /* Show the overlay on hover */
}

.image-container:hover .upload-overlay {
  opacity: 1; /* Show the overlay when hovered */
}

.el-button + .el-button {
  margin-left: 0;
}

@media screen and (max-width: 540px) {
  .areas-container {
    width: 92%;
    flex-wrap: wrap;
  }
  .action-area {
    margin: 0 5px;
    min-height: 50px;
  }
  .image-area {
    width: 100%;
  }
  .image-preview {
    margin-top: 0;
    width: calc(100% - 10px);
    height: 180px;
  }
  .image-preview p {
    line-height: 20px;
    margin: 0;
    font-size: 14px;
  }
.el-upload--picture-card {
    width: 60px;
    height: 60px;
    line-height: 70px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PicToWebp.vue